module.exports = __webpack_public_path__ + "img/last-join.3aa105fe.svg";